
import Vue from 'vue'
import { FinancialInvoice } from '@/domains/global/models/job-financials.model'
import { Component, Prop } from 'vue-property-decorator'
import PaymentTypeCard from '../components/PaymentTypeCard.vue'
import CardCheckout from '../components/card-checkout.vue'
import CostSummary from '../components/cost-summary.vue'
import axios from 'axios'

@Component({
  components: { PaymentTypeCard, CardCheckout, CostSummary }
})
export default class CheckoutPage extends Vue {
  invoice: Partial<FinancialInvoice> | null = null
  isLoading = false

  get invoiceNumber() {
    return this.$route.params.id
  }

  mounted() {
    this.getInvoice()
  }

  async getInvoice() {
    try {
      const response = await axios.get(`/invoices/by-number/${this.$route.params.invoiceNumber}`)
      this.invoice = response.data as FinancialInvoice
      if (this.invoice?.status === 'paid') {
        this.gobackToJob()
      }
    } catch (err) {
      this.$store.dispatch('error', err)
    }
  }

  updateLoading(value: any) {
    this.isLoading = value
  }

  gobackToJob() {
    if (this.invoice?.jobId)  {
      this.$router.push({ name: 'jobs-read', params: { id: this.invoice.jobId.toString() } })
    } else {
      this.$router.push({ name: 'jobs-list' } )
    }
  }

  onPaymentSuccess(paymentDetails: any) {
    this.$store.dispatch('success', 'Successfully Paid Job')
    this.gobackToJob()
  }

  submitCardPayment() {
    const form = this.$refs.cardPaymentForm as any
    form.submit()
  }

}
